import React, { useState, useEffect } from 'react';
import './AboutUs.css';
import slide3Image from '../abouthero1.jpeg';
import about1Image from '../about1.png';
import card3Image from '../card3.jpeg';
import setsImage from '../stes.jpeg';
import gaushalaImage from '../gaushala.png';
import cow1Image from '../cow1.png';
import cow2Image from '../cow2.png';
import cow3Image from '../cow3.png';
import cow4Image from '../cow4.png';
import Contact from '../components/Contact';


const AboutUs = () => {
  const [currentGoshalaSlide, setCurrentGoshalaSlide] = useState(0);

  const goshalaImages = [
    {
      id: 1,
      image: gaushalaImage,
      alt: "Goshala at Sri Veda Gurukulam"
    },
    {
      id: 2,
      image: cow1Image,
      alt: "Cow 1 at Goshala"
    },
    {
      id: 3,
      image: cow2Image,
      alt: "Cow 2 at Goshala"
    },
    {
      id: 4,
      image: cow3Image,
      alt: "Cow 3 at Goshala"
    },
    {
      id: 5,
      image: cow4Image,
      alt: "Cow 4 at Goshala"
    }
  ];

  // Auto-play functionality for Goshala carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentGoshalaSlide((prev) => (prev + 1) % goshalaImages.length);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(interval);
  }, [goshalaImages.length]);

  const nextGoshalaSlide = () => {
    setCurrentGoshalaSlide((prev) => (prev + 1) % goshalaImages.length);
  };

  const prevGoshalaSlide = () => {
    setCurrentGoshalaSlide((prev) => (prev - 1 + goshalaImages.length) % goshalaImages.length);
  };
  return (
    <div className="about-us-page">
      {/* Hero Section */}
      <section className="about-hero-section">
        <div className="about-hero-image">
          <img src={slide3Image} alt="About Sri Veda Gurukulam" />
          <div className="about-hero-overlay">
            <div className="about-hero-content">
              <h1 className="about-hero-title">About Sri Veda <br></br>Gurukulam</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="our-story-section">
        <div className="container">
          <div className="our-story-content">
            <div className="story-text">
              <div className="aboutus-section-header">
                <div className="aboutus-section-line"></div>
                <h2 className="aboutus-section-title">Our Story</h2>
              </div>
              
              <h3 className="aboutus-story-main-title">Kanishana Acharya Raghuman (1940 – 2023)</h3>
              
              <h4 className="story-subtitle">Journey of the Guru:</h4>
              
              <p className="story-paragraph">
                Kanishana Acharya Raghuman began his spiritual journey at a young age, dedicating 
                his life to the study and practice of the Vedas. Through years of disciplined learning, 
                devotion, and guidance under revered Gurus, he mastered Vedic chanting, rituals, 
                and Samskaras.
              </p>
              
              <p className="story-paragraph">
                Recognizing the gradual decline of traditional Vedic education, he envisioned a 
                Gurukul where sacred knowledge could be preserved in its purest form. In 1987, this 
                vision took shape with the establishment of Sri Veda Gurukulam.
              </p>
              
              <p className="story-paragraph">
                Throughout his life, Acharya Raghuman selflessly trained students, performed sacred 
                rituals for families, and served society through Dharma. His teachings emphasized 
                discipline, humility, and living Vedic wisdom as a way of life.
              </p>
              
              <p className="story-paragraph">
                Even after attaining Samadhi in 2023, his values, teachings, and spiritual legacy 
                continue through the Gurukulam and its students.
              </p>
            </div>
            
            <div className="story-image">
              <img src={about1Image} alt="Kanishana Acharya Raghuman" />
            </div>
          </div>
        </div>
      </section>

      {/* Our Origin Section */}
      <section className="our-origin-section">
        <div className="container">
          <div className="origin-content">
            <div className="origin-header">
              <div className="origin-line"></div>
              <h2 className="origin-title">Our Origin</h2>
            </div>
            
            <div className="origin-text">
              <div className="origin-paragraph-container">
                <p className="origin-paragraph">
                  Established in 1987, Sri Veda Gurukulam was founded with the sacred vision of preserving and sustaining Vedic education in its purest and most 
                  authentic form. At a time when traditional systems of learning were gradually fading, the Gurukulam emerged as a dedicated spiritual institution 
                  committed to safeguarding the timeless wisdom of the Vedas for future generations.
                </p>
              </div>
              
              <div className="origin-paragraph-container">
                <p className="origin-paragraph">
                  Sri Veda Gurukulam was envisioned as a sacred residential learning space, where students could live, learn, and evolve under the direct guidance of 
                  learned Acharyas, in accordance with the ancient Guru-Shishya Parampara. Education at the Gurukulam extends beyond academic instruction; it 
                  emphasizes discipline, character building, spiritual practice, and righteous conduct as integral aspects of learning.
                </p>
              </div>
              
              <div className="origin-paragraph-container">
                <p className="origin-paragraph">
                  Rooted in time-honored traditions, the Gurukulam nurtures students through daily Yagya, mantra sadhana, self-study, and a life of simplicity and 
                  service. The environment encourages humility, self-restraint, and a deep sense of responsibility toward society and the nation. Knowledge is 
                  imparted not merely as information, but as a way of life aligned with Dharma.
                </p>
              </div>
              
              <div className="origin-paragraph-container">
                <p className="origin-paragraph">
                  Over the years, Sri Veda Gurukulam has remained steadfast in its mission to create individuals who embody Vedic values, moral strength, and 
                  spiritual clarity. Through unwavering commitment to authentic Vedic practices, the Gurukulam continues to serve as a beacon of Sanatan wisdom, 
                  contributing to cultural preservation, spiritual awakening, and national well-being.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Mission Section */}
      <section className="our-mission-section">
        <div className="container">
          <div className="our-mission-content">
            <div className="mission-text">
              <div className="mission-header">
                <div className="mission-line"></div>
                <h2 className="mission-title">Our Mission</h2>
              </div>
              
              <p className="mission-paragraph">
                Our mission is to impart authentic Vedic education through disciplined learning, 
                spiritual practice, and the Guru-Shishya tradition. We nurture individuals to live by 
                Dharma, cultivating moral strength, self-discipline, and inner awareness. Through the 
                study of Vedas, Yagya, and righteous living, we prepare students to serve society 
                with integrity, contribute to social harmony, preserve cultural heritage, and uphold 
                the timeless values of Sanatan Dharma for the welfare of the nation.
              </p>
              
              <div className="vision-header">
                <div className="vision-line"></div>
                <h2 className="vision-title">Our Vision</h2>
              </div>
              
              <p className="vision-paragraph">
                Our vision is to ensure the continuity of Vedic wisdom and sacred traditions for future 
                generations by preserving their authenticity and relevance. We aspire to nurture 
                individuals rooted in Dharma, spiritual discipline, and moral integrity, enabling them 
                to uphold Sanatan values, contribute to social harmony, and guide society toward a 
                balanced, righteous, and enlightened way of life.
              </p>
            </div>
            
            <div className="mission-image">
              <img src={card3Image} alt="Our Mission and Vision" />
            </div>
          </div>
        </div>
      </section>

      {/* Our Philosophy Section */}
      <section className="our-philosophy-section">
        <div className="container">
          <div className="philosophy-content">
            <div className="philosophy-header">
              <div className="philosophy-line"></div>
              <h2 className="philosophy-title">Our Philosophy</h2>
            </div>
            
            <div className="philosophy-points">
              <ul className="philosophy-list">
                <li className="philosophy-item">
                  Knowledge must be lived and practiced, not merely studied, to become meaningful and transformative.
                </li>
                <li className="philosophy-item">
                  Discipline forms the foundation of spiritual growth, guiding thought, conduct, and character.
                </li>
                <li className="philosophy-item">
                  True learning flourishes within the Guru-Shishya Parampara, where wisdom is transmitted through guidance, example, and experience.
                </li>
                <li className="philosophy-item">
                  Dharma and selfless service are essential to a purposeful and fulfilling human life.
                </li>
              </ul>
            </div>
            
            <div className="gurukul-way-header">
              <div className="gurukul-way-line"></div>
              <h2 className="gurukul-way-title">The Gurukul Way</h2>
            </div>
            
            <div className="gurukul-way-content">
              <p className="gurukul-way-paragraph">
                At Sri Veda Gurukulam, education goes beyond books and classrooms. Students follow a disciplined daily routine that includes Vedic chanting, 
                scriptural study, practical ritual training, and selfless seva. This holistic approach nurtures intellectual clarity, moral strength, and spiritual 
                awareness, shaping individuals who live by Dharma and apply Vedic wisdom as a way of life.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What Sets Us Apart Section */}
      <section className="what-sets-us-apart-section">
        <div className="container">
          <div className="sets-apart-content">
            <div className="sets-apart-text">
              <div className="sets-apart-header">
                <div className="sets-apart-line"></div>
                <h2 className="sets-apart-title">What Sets Us Apart</h2>
              </div>
              
              <div className="sets-apart-points">
                <div className="sets-apart-point">
                  <h3 className="point-title">Authentic Gurukul Education</h3>
                  <p className="point-description">
                    A traditional Gurukul-based system rooted in the Guru-Shishya 
                    Parampara, ensuring learning in its pure and disciplined form.
                  </p>
                </div>
                
                <div className="sets-apart-point">
                  <h3 className="point-title">Decades of Trust & Service</h3>
                  <p className="point-description">
                    Established with a long-standing commitment to preserving and 
                    practicing Vedic traditions with integrity and consistency.
                  </p>
                </div>
                
                <div className="sets-apart-point">
                  <h3 className="point-title">Experienced Acharyas</h3>
                  <p className="point-description">
                    Guidance under learned and dedicated Acharyas who impart wisdom 
                    through both teaching and personal example.
                  </p>
                </div>
                
                <div className="sets-apart-point">
                  <h3 className="point-title">Discipline & Values</h3>
                  <p className="point-description">
                    Strong emphasis on discipline, humility, moral values, and character 
                    development as the foundation of spiritual growth.
                  </p>
                </div>
                
                <div className="sets-apart-point">
                  <h3 className="point-title">Balanced Learning</h3>
                  <p className="point-description">
                    Equal importance given to scriptural knowledge and practical 
                    application through daily rituals and lived practice.
                  </p>
                </div>
                
                <div className="sets-apart-point">
                  <h3 className="point-title">Goshala & Living Dharma</h3>
                  <p className="point-description">
                    An active Goshala and regular Dharma-centered events that bring 
                    Sanatan values alive through service and community participation.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="sets-apart-image">
              <img src={setsImage} alt="What Sets Us Apart" />
            </div>
          </div>
        </div>
      </section>

      {/* Goshala Section */}
      <section className="goshala-section">
        <div className="container">
          <div className="goshala-content">
            <div className="goshala-header">
              <div className="goshala-line"></div>
              <h2 className="goshala-title">Goshala</h2>
            </div>
            
            <div className="goshala-text">
              <p className="goshala-paragraph">
                At Sri Veda Gurukulam, the <strong>Goshala</strong> is a living embodiment of <strong>Sanatan Dharma</strong> and an integral part of daily spiritual life. Rooted in the tradition of 
                Goseva, the Goshala reflects values of compassion, responsibility, and reverence for all living beings. <strong>Cows</strong> are cared for with <strong>dignity</strong> and <strong>respect</strong>, 
                following ethical and traditional practices.
              </p>
              
              <p className="goshala-paragraph">
                <strong>Students</strong> actively participate in <strong>Goseva</strong> as part of their disciplined routine, learning humility, service, and harmony with nature. Through this 
                practice, the Goshala becomes a space of learning where Dharma is lived, not merely taught, fostering spiritual <strong>awareness</strong> and social 
                responsibility.
              </p>
            </div>
            
            <div className="goshala-carousel">
              {/* Navigation Buttons */}
              <button className="goshala-nav-btn goshala-prev-btn" onClick={prevGoshalaSlide}>
                &#8249;
              </button>
              
              <button className="goshala-nav-btn goshala-next-btn" onClick={nextGoshalaSlide}>
                &#8250;
              </button>

              {/* Current Image */}
              <div className="goshala-image-display">
                <img 
                  src={goshalaImages[currentGoshalaSlide].image} 
                  alt={goshalaImages[currentGoshalaSlide].alt}
                  className="goshala-carousel-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
            <Contact />

    </div>
  );
};

export default AboutUs;